/**
 * @generated SignedSource<<03f6fa4cb83f2cc648c0e2daa075c3c7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type hooksScmpArticleReactionConfigAppConfigQuery$variables = {};
export type hooksScmpArticleReactionConfigAppConfigQuery$data = {
  readonly appConfig: {
    readonly json: unknown | null;
  } | null;
};
export type hooksScmpArticleReactionConfigAppConfigQuery = {
  response: hooksScmpArticleReactionConfigAppConfigQuery$data;
  variables: hooksScmpArticleReactionConfigAppConfigQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "entityId": "scmp_pwa_article_reaction"
    }
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "json",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "hooksScmpArticleReactionConfigAppConfigQuery",
    "selections": [
      {
        "alias": null,
        "args": (v0/*: any*/),
        "concreteType": "AppConfig",
        "kind": "LinkedField",
        "name": "appConfig",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ],
        "storageKey": "appConfig(filter:{\"entityId\":\"scmp_pwa_article_reaction\"})"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "hooksScmpArticleReactionConfigAppConfigQuery",
    "selections": [
      {
        "alias": null,
        "args": (v0/*: any*/),
        "concreteType": "AppConfig",
        "kind": "LinkedField",
        "name": "appConfig",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": "appConfig(filter:{\"entityId\":\"scmp_pwa_article_reaction\"})"
      }
    ]
  },
  "params": {
    "cacheID": "98dcb2529e1fb3fd9878d78ec1b26fb1",
    "id": null,
    "metadata": {},
    "name": "hooksScmpArticleReactionConfigAppConfigQuery",
    "operationKind": "query",
    "text": "query hooksScmpArticleReactionConfigAppConfigQuery {\n  appConfig(filter: {entityId: \"scmp_pwa_article_reaction\"}) {\n    json\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "4a771a87acfdb9874590fa32768a36fc";

export default node;
